import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
import { nextIteration } from "./_nextIteration.js";
export const each = (source, action) => {
    return new BasicParallelEnumerable(nextIteration(source, (x) => {
        action(x);
        return x;
    }));
};
